export const chainHandlers =
  (...handlers) =>
  e =>
    handlers.reduce((result, handler) => (handler ? handler(e) : result), null);
